import { render, staticRenderFns } from "./GalleryFoot.vue?vue&type=template&id=c9c6d9ae&scoped=true&"
import script from "./GalleryFoot.vue?vue&type=script&lang=js&"
export * from "./GalleryFoot.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFoot.vue?vue&type=style&index=0&id=c9c6d9ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c6d9ae",
  null
  
)

export default component.exports